import { render, staticRenderFns } from "./NewsDashboardCard.vue?vue&type=template&id=24810824"
import script from "./NewsDashboardCard.vue?vue&type=script&lang=js"
export * from "./NewsDashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports